// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_1iWJ1","topSection":"topSection_1uaiX","footerLinks":"footerLinks_2Dgms","footerCopyright":"footerCopyright_33AUu"};